// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dJhKODbZTYErHW {
  display: block;
  position: relative;
  box-sizing: border-box;
  width: 100%;
  border: none;
  border-radius: var(--ds-border-radius-200, 8px);
  box-shadow: none;
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.dJhKODbZTYErHW:hover {
  background-color: var(--ds-background-neutral, #091e4224);
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.uDgVrA8gIoTHUR {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: var(--ds-space-050, 4px);
  gap: var(--ds-space-100, 8px);
}
.hHuNj4nYhV2okU {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 30px;
  border: 1px solid var(--ds-border, #091e4224);
  border-radius: var(--ds-border-radius-100, 4px);
  background-color: var(--ds-background-accent-gray-subtler, #dcdfe4);
}
.K2R8ER7v14nkPF {
  flex: 1;
  overflow: hidden;
  color: var(--ds-text, #172b4d);
  font-weight: var(--ds-font-weight-medium, 500);
  line-height: 18px;
  word-wrap: break-word;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
`, ""]);
// Exports
export var tile = `dJhKODbZTYErHW`;
export var details = `uDgVrA8gIoTHUR`;
export var icon = `hHuNj4nYhV2okU`;
export var title = `K2R8ER7v14nkPF`;
export default ___CSS_LOADER_EXPORT___;
